// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sectionProdutos_sectionProdutosContainer__88ZTU{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.sectionProdutos_sectionProdutosContainer__88ZTU h1{
    font-family: var(--goldplay-regular);
    font-weight: 400;
    font-size: 24px;
    padding: 70px 0 40px 0;
}

.sectionProdutos_sectionProdutosFilterItemsPrimeiraLinha__8zR92{
    display: grid;
    grid-template-columns: repeat(5,1fr);
    column-gap: 20px;
    transform: translate(1.5vw,0);
}

.sectionProdutos_sectionProdutosFilterItemsSegundaLinha__aprw4{
    display: grid;
    grid-template-columns: repeat(6,auto);
    padding-top: 15px;
    column-gap: 50px;
    transform: translate(1.5vw,0);
}

.sectionProdutos_sectionProdutosFilterItem__muED9,
.sectionProdutos_link__S2hst,
.sectionProdutos_linkActive__py4YQ,
.sectionProdutos_link__S2hst:hover,
.sectionProdutos_linkActive__py4YQ:hover{
    cursor: pointer;
    text-decoration: none;
    font-family: var(--goldplay-regular);
    color:var(--gray-11);
    font-size: 19.2px;    
    line-height: 17px;
    text-align: center;
}

.sectionProdutos_link__S2hst:hover{
    border-bottom: 2px solid var(--secundary); 
}

.sectionProdutos_linkActive__py4YQ{
    transition: 0.4s;
    border-bottom: 2px solid var(--secundary); 
}

.sectionProdutos_sectionProdutosRecargaItems__945-6{
    margin-top:30px;
    margin-left: 2.5rem;
    display: grid;
    grid-template-columns: repeat(7,1fr);
    column-gap: 20px;
    row-gap: 15px;
}

.sectionProdutos_sectionProdutosRecargaItem__DTOb8{
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 20px;
    width: 100px;
    height: 100px;
    background: var(--gray-2);
}

.sectionProdutos_sectionProdutosRecargaItem__DTOb8:hover{
    transition: 0.4s;
    cursor: pointer;
    border: 1.5px solid var(--secundary);
}

.sectionProdutos_sectionProdutosRecargaItem__DTOb8 img{
    width: 70px;
    height: 70px;
}
`, "",{"version":3,"sources":["webpack://./src/object/Section/produtos/sectionProdutos.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,oCAAoC;IACpC,gBAAgB;IAChB,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,oCAAoC;IACpC,gBAAgB;IAChB,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,iBAAiB;IACjB,gBAAgB;IAChB,6BAA6B;AACjC;;AAEA;;;;;IAKI,eAAe;IACf,qBAAqB;IACrB,oCAAoC;IACpC,oBAAoB;IACpB,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,gBAAgB;IAChB,yCAAyC;AAC7C;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,aAAa;IACb,oCAAoC;IACpC,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,oCAAoC;AACxC;;AAEA;IACI,WAAW;IACX,YAAY;AAChB","sourcesContent":[".sectionProdutosContainer{\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n}\n\n.sectionProdutosContainer h1{\n    font-family: var(--goldplay-regular);\n    font-weight: 400;\n    font-size: 24px;\n    padding: 70px 0 40px 0;\n}\n\n.sectionProdutosFilterItemsPrimeiraLinha{\n    display: grid;\n    grid-template-columns: repeat(5,1fr);\n    column-gap: 20px;\n    transform: translate(1.5vw,0);\n}\n\n.sectionProdutosFilterItemsSegundaLinha{\n    display: grid;\n    grid-template-columns: repeat(6,auto);\n    padding-top: 15px;\n    column-gap: 50px;\n    transform: translate(1.5vw,0);\n}\n\n.sectionProdutosFilterItem,\n.link,\n.linkActive,\n.link:hover,\n.linkActive:hover{\n    cursor: pointer;\n    text-decoration: none;\n    font-family: var(--goldplay-regular);\n    color:var(--gray-11);\n    font-size: 19.2px;    \n    line-height: 17px;\n    text-align: center;\n}\n\n.link:hover{\n    border-bottom: 2px solid var(--secundary); \n}\n\n.linkActive{\n    transition: 0.4s;\n    border-bottom: 2px solid var(--secundary); \n}\n\n.sectionProdutosRecargaItems{\n    margin-top:30px;\n    margin-left: 2.5rem;\n    display: grid;\n    grid-template-columns: repeat(7,1fr);\n    column-gap: 20px;\n    row-gap: 15px;\n}\n\n.sectionProdutosRecargaItem{\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 20px;\n    width: 100px;\n    height: 100px;\n    background: var(--gray-2);\n}\n\n.sectionProdutosRecargaItem:hover{\n    transition: 0.4s;\n    cursor: pointer;\n    border: 1.5px solid var(--secundary);\n}\n\n.sectionProdutosRecargaItem img{\n    width: 70px;\n    height: 70px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sectionProdutosContainer": `sectionProdutos_sectionProdutosContainer__88ZTU`,
	"sectionProdutosFilterItemsPrimeiraLinha": `sectionProdutos_sectionProdutosFilterItemsPrimeiraLinha__8zR92`,
	"sectionProdutosFilterItemsSegundaLinha": `sectionProdutos_sectionProdutosFilterItemsSegundaLinha__aprw4`,
	"sectionProdutosFilterItem": `sectionProdutos_sectionProdutosFilterItem__muED9`,
	"link": `sectionProdutos_link__S2hst`,
	"linkActive": `sectionProdutos_linkActive__py4YQ`,
	"sectionProdutosRecargaItems": `sectionProdutos_sectionProdutosRecargaItems__945-6`,
	"sectionProdutosRecargaItem": `sectionProdutos_sectionProdutosRecargaItem__DTOb8`
};
export default ___CSS_LOADER_EXPORT___;
